import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/auth.store';
import { LoginPage } from './pages/LoginPage';
import { DashboardLayout } from './layouts/DashboardLayout';
import { PlatformOverviewPage } from './pages/PlatformOverviewPage';
import { WorldsPage } from './pages/WorldsPage';
import { WorldDetailPage } from './pages/WorldDetailPage';
import { RewardRulesPage } from './pages/RewardRulesPage';
import { AnomaliesPage } from './pages/AnomaliesPage';
import { ReportsPage } from './pages/ReportsPage';
import { ExchangeRatesPage } from './pages/ExchangeRatesPage';
import { GrafanaDashboardPage } from './pages/GrafanaDashboardPage';
import { CentralBankPage } from './pages/CentralBankPage';
import { UsersPage } from './pages/UsersPage';
import { HoldersPage } from './pages/HoldersPage';
import { HolderDetailPage } from './pages/HolderDetailPage';
import { HolderTimelinePage } from './pages/HolderTimelinePage';
import { AuditLogPage } from './pages/AuditLogPage';
import { ServiceHealthPage } from './pages/ServiceHealthPage';
import { DlqPage } from './pages/DlqPage';
import { WorldComparePage } from './pages/WorldComparePage';
import { RedpandaPage } from './pages/RedpandaPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.accessToken);
  return token ? <>{children}</> : <Navigate to="/login" replace />;
}

function AdminOnlyRoute({ children }: { children: React.ReactNode }) {
  const role = useAuthStore((s) => s.role);
  if (role === 'WORLD_OWNER') return <Navigate to="/overview" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/overview" replace />} />
          <Route path="overview" element={<PlatformOverviewPage />} />
          <Route path="worlds" element={<WorldsPage />} />
          <Route path="worlds/:worldId" element={<WorldDetailPage />} />
          <Route path="worlds/:worldId/rules" element={<RewardRulesPage />} />
          <Route path="holders" element={<HoldersPage />} />
          <Route path="holders/:holderId" element={<HolderDetailPage />} />
          <Route path="holder-timeline" element={<HolderTimelinePage />} />
          <Route path="users" element={<AdminOnlyRoute><UsersPage /></AdminOnlyRoute>} />
          <Route path="exchange-rates" element={<ExchangeRatesPage />} />
          <Route path="anomalies" element={<AnomaliesPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="grafana" element={<GrafanaDashboardPage />} />
          <Route path="central-bank" element={<AdminOnlyRoute><CentralBankPage /></AdminOnlyRoute>} />
          <Route path="audit-log" element={<AuditLogPage />} />
          <Route path="service-health" element={<AdminOnlyRoute><ServiceHealthPage /></AdminOnlyRoute>} />
          <Route path="dlq" element={<AdminOnlyRoute><DlqPage /></AdminOnlyRoute>} />
          <Route path="redpanda" element={<AdminOnlyRoute><RedpandaPage /></AdminOnlyRoute>} />
          <Route path="world-compare" element={<WorldComparePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
